import { render, staticRenderFns } from "./coverPicker.vue?vue&type=template&id=fc6e7706&"
import script from "./coverPicker.ts?vue&type=script&lang=js&"
export * from "./coverPicker.ts?vue&type=script&lang=js&"
import style0 from "./coverPicker.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports